module.exports = __webpack_public_path__ + "static/media/nft-37.86fc553d.jpg";